var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "chat-widget" },
    [
      _c(
        "b-card-title",
        { staticClass: "mb-75" },
        [
          _vm._v(" Comentarios "),
          _vm.isLoading
            ? _c("b-spinner", {
                staticClass: "float-right",
                attrs: { small: "", variant: "primary" }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "activity-comments pt-4" },
        [
          _vm.hasMorePages
            ? _c(
                "a",
                {
                  staticClass: "btn-block btn btn-link",
                  on: { click: _vm.fetchMore }
                },
                [_vm._v(" Cargar mas comentarios ")]
              )
            : _vm._e(),
          _vm._l(_vm.commentsSorted, function(comment) {
            return _c(
              "div",
              { key: comment.id, staticClass: "d-flex align-items-start mb-4" },
              [
                !comment.userAvatar
                  ? _c("b-avatar", {
                      staticClass: "mt-25 mr-75",
                      attrs: {
                        text: _vm._f("avatarName")(comment.username),
                        size: "34"
                      }
                    })
                  : _c("b-avatar", {
                      staticClass: "mt-25 mr-75",
                      attrs: { src: comment.userAvatar, size: "34" }
                    }),
                _c("div", { staticClass: "profile-user-info w-100" }, [
                  _c(
                    "div",
                    {
                      attrs: {
                        title: _vm._f("dateFormatTime")(comment.createdAt)
                      }
                    },
                    [
                      _c("small", [_vm._v(_vm._s(comment.username))]),
                      _vm._v(" - "),
                      _c("small", [
                        _vm._v(_vm._s(_vm._f("fromNow")(comment.createdAt)))
                      ])
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between"
                    },
                    [
                      _c("h6", { staticClass: "mb-0" }, [
                        _vm._v(" " + _vm._s(comment.text) + " ")
                      ])
                    ]
                  ),
                  comment.attachments.length
                    ? _c(
                        "div",
                        { staticClass: "my-1" },
                        _vm._l(comment.attachments, function(attachment) {
                          return _c("DownloadFile", {
                            key: comment.id + "-attachment-" + attachment.id,
                            staticClass:
                              "btn btn-outline-secondary btn-sm mr-1 mb-1",
                            attrs: {
                              path: attachment.url,
                              name: attachment.name
                            }
                          })
                        }),
                        1
                      )
                    : _vm._e()
                ])
              ],
              1
            )
          })
        ],
        2
      ),
      _c(
        "b-form",
        {
          attrs: { "data-vv-scope": "comment-form" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.onSubmit()
            }
          }
        },
        [
          _c(
            "b-form-group",
            [
              _c("b-form-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                attrs: {
                  rows: "3",
                  placeholder: "Agregar comentario",
                  name: "comment",
                  state: _vm.errors.has("comment-form.comment") ? false : null
                },
                model: {
                  value: _vm.comment.text,
                  callback: function($$v) {
                    _vm.$set(_vm.comment, "text", $$v)
                  },
                  expression: "comment.text"
                }
              }),
              _c("b-form-invalid-feedback", [
                _vm._v(
                  " " + _vm._s(_vm.errors.first("comment-form.comment")) + " "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mb-1" },
            _vm._l(_vm.attachments, function(attachment, index) {
              return _c(
                "b-button",
                {
                  key: "attachment-" + attachment.id,
                  staticClass: "mr-1 mb-1",
                  attrs: {
                    variant: "outline-secondary form-attachment",
                    size: "sm"
                  },
                  on: {
                    click: function($event) {
                      return _vm.deleteCommentAttachment(index)
                    }
                  }
                },
                [
                  _vm._v(" " + _vm._s(attachment.name) + " "),
                  _c("feather-icon", { attrs: { icon: "PaperclipIcon" } })
                ],
                1
              )
            }),
            1
          ),
          _c(
            "div",
            {
              directives: [
                {
                  name: "has-permission",
                  rawName: "v-has-permission",
                  value: "ED080",
                  expression: "'ED080'"
                }
              ],
              staticClass: "d-flex"
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "ripple",
                      rawName: "v-ripple.400",
                      value: "rgba(255, 255, 255, 0.15)",
                      expression: "'rgba(255, 255, 255, 0.15)'",
                      modifiers: { "400": true }
                    }
                  ],
                  staticClass: "mr-1",
                  attrs: {
                    size: "sm",
                    variant: "primary",
                    type: "submit",
                    disabled: _vm.isLoading
                  }
                },
                [_vm._v(" Comentar ")]
              ),
              _c("UploadFile", {
                attrs: {
                  permission: "*",
                  "upload-to": _vm.attachmentUrl,
                  "type-button": "small",
                  "button-class": ""
                },
                on: { input: _vm.addCommentAttachment }
              }),
              _c("div", { staticClass: "col-md-12" }, [
                _vm.loadFileFailed
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                        staticStyle: { height: "32px" }
                      },
                      [
                        _c("span", { staticClass: "span-text-validation" }, [
                          _vm._v(
                            " La carga del archivo falló, intentalo de nuevo "
                          )
                        ])
                      ]
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }